import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learnerEnrollRes;
export const learnerEnrollTodo = createAsyncThunk('learnerEnroll', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/approval_request',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": data.id,
                "created_by": data.created_by,
                "course_approval_id": data && data.lms_course_approvals && data.lms_course_approvals[0] && data.lms_course_approvals[0].id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learnerEnrollRes = res.data
    } catch (error) {
        return learnerEnrollRes = error.response.data
    }
})